import { Alert,Button,Col,Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

export function ApplicationReceived() {
    return (
        <Container>
            <h3 className="text-pp-secondary font-weight-bold">ABPN Application Submission Confirmation</h3>
            <hr></hr>
            <Row className="mt-5">
                <Col>
                    <Alert variant="pp-alert-success font-weight-bold">Thank you. Your ABPN examination application was submitted successfully. If you made a payment, a receipt has been emailed to you. </Alert>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col md={{ offset: 5}}>
                    <Link to="/"><Button variant="pp-primary">Back To Dashboard</Button></Link>
                </Col>
            </Row>
        </Container>
    );
}

export default ApplicationReceived;